import { Box, IconButton, Typography } from "@mui/material";
import Close from "@mui/icons-material/Close";

interface IProps {
  closePopUp: () => void;
}

const PopUpHeader: React.FC<IProps> = ({ closePopUp }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={2.25}
      color="#667085"
    >
      <Typography
        variant="h5"
        color="text.primary"
        fontSize={{ xs: "1.5rem", md: "1.5rem" }}
      >
        Cart
      </Typography>
      <IconButton
        size="small"
        aria-label="close cart pop-up"
        aria-controls="cart pop-up"
        aria-haspopup="true"
        onClick={closePopUp}
        color="inherit"
      >
        <Close />
      </IconButton>
    </Box>
  );
};

export default PopUpHeader;
